import { toRem } from '../../utils/pixelUtils';

const expandibleAreaStyles = {
    pr: 0,
    pb: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: '8px'
};

const expandibleButtonStyles = {
    py: 1,
    px: 0
};

const expandibleButtonStylesTradeIn = {
    alignItems: 'flex-start',
    '& svg': {
        alignSelf: 'center'
    }
};

const labelStyles = {
    color: '#005BA8'
};

const accordionLabelStyles = {
    color: '#6d6d6d'
};

const mainValueStyles = {
    fontWeight: '600'
};

const secondaryValueStyles = {
    fontWeight: '600',
    fontSize: '14px'
};

const defaultGridProps = {
    flexDirection: 'column'
};

const detailedViewLabelStyles = {
    color: '#000000',
    fontSize: '0.857rem !important'
};

const detailedViewValueStyles = {
    fontWeight: '700',
    fontSize: '1.143rem !important'
};

const detailedViewGridProps = {
    display: 'grid',
    columnGap: '3rem',
    gridTemplateColumns: 'repeat(3, 1fr)'
};

const detailedViewSecondaryGridProps = {
    display: 'grid',
    rowGap: '0.571rem',
    pt: '0.571rem !important'
};

const primaryValueNodeStyles = {
    fontWeight: '600',
    fontSize: `${toRem(16)}`
};

const nestedValueNodeStyles = {
    fontWeight: '400',
    fontSize: `${toRem(14)}`
};
const nestedLabelNodeStyles = {
    fontSize: `${toRem(12)} !important`
};

export {
    expandibleAreaStyles,
    expandibleButtonStyles,
    expandibleButtonStylesTradeIn,
    labelStyles,
    mainValueStyles as valueStyles,
    secondaryValueStyles,
    detailedViewLabelStyles,
    detailedViewValueStyles,
    defaultGridProps,
    detailedViewGridProps,
    detailedViewSecondaryGridProps,
    accordionLabelStyles,
    primaryValueNodeStyles,
    nestedLabelNodeStyles,
    nestedValueNodeStyles
};
